"use client";

import { useEffect } from "react";

import { type Country } from "@/domain/country";

import { ensurePayPalMessagesSdk } from "./paypal-bnpl.provider";
import * as styles from "./PayPalBnplMessage.module.scss";

export interface PayPalBnplMessageClientProps {
	clientTokenEndpoint: string;
	amount: number;
	currency: "USD" | "CAD";
	country: Country;
}

export function PayPalBnplMessageClient({
	clientTokenEndpoint,
	amount,
	currency,
	country
}: PayPalBnplMessageClientProps): JSX.Element {
	useEffect(() => {
		void ensurePayPalMessagesSdk({
			endpoint: clientTokenEndpoint,
			country,
			currency
		}).catch(() => undefined);
	}, [clientTokenEndpoint, country, currency]);

	return (
		<div
			className={styles?.["paypalBnplMessage"]}
			data-component="PayPalBnplMessage"
		>
			<div
				data-pp-message=""
				data-pp-style-layout="text"
				data-pp-style-logo-type="inline"
				data-pp-style-text-color="black"
				data-pp-style-text-size="16"
				data-pp-placement="product"
				data-pp-amount={amount.toFixed(2)}
				data-pp-currency={currency}
			/>
		</div>
	);
}
